import { Navigate, useLocation, useParams } from "react-router-dom";
import { ticketListViewPath } from "@/features/tickets/model/ticket-list-views";

/** 兼容旧的 `/tickets/:ticketId` 链接，并为它补上默认的「全部工单」列表上下文。 */
export function LegacyTicketDetailRedirect() {
  const location = useLocation();
  const { ticketId } = useParams();

  if (!ticketId) return <Navigate replace to={ticketListViewPath("all")} />;

  return <Navigate replace to={`${ticketListViewPath("all")}/${encodeURIComponent(ticketId)}${location.search}${location.hash}`} />;
}
